/**
 * Auto-spawn: moderskeppet spawnar en unit av spelarens aktiva typ enligt
 * spawnintervallet i config. Spawnposition får liten seedad jitter så att
 * nya units inte staplas exakt på varandra.
 */
import type { SimConfig } from './config';
import { clamp, fpFromWorld } from './fixed';
import { rngRange } from './prng';
import type { GameState } from './state';
import { PLAYER_IDS, spawnIntervalTicks, unitMaxHp } from './state';

export function updateSpawning(state: GameState, config: SimConfig): void {
  const jitter = fpFromWorld(config.match.spawnJitterRadius);
  const maxX = fpFromWorld(config.match.mapSize.width);
  const maxY = fpFromWorld(config.match.mapSize.height);

  for (const id of PLAYER_IDS) {
    const ship = state.motherships[id];
    const player = state.players[id];

    if (config.match.mothership.spawnPausedDuringRetreat && ship.retreatTicksLeft > 0) continue;

    ship.spawnCooldownTicks--;
    if (ship.spawnCooldownTicks > 0) continue;
    ship.spawnCooldownTicks = spawnIntervalTicks(player, config);

    const armySize = state.units.reduce((n, u) => n + (u.owner === id ? 1 : 0), 0);
    if (armySize >= config.match.maxArmySize) continue;

    const jx = rngRange(state.rngState, -jitter, jitter);
    const jy = rngRange(jx.state, -jitter, jitter);
    state.rngState = jy.state;

    const maxHp = unitMaxHp(player, config);
    state.units.push({
      id: state.nextUnitId++,
      owner: id,
      family: player.activeFamily,
      tier: player.activeTier,
      x: clamp(ship.x + jx.value, 0, maxX),
      y: clamp(ship.y + jy.value, 0, maxY),
      hp: maxHp,
      maxHp,
    });
  }
}
